<template>
  <div class="row g-4">
    <div class="col-lg-6 col-12">
      <div class="form-field"><label class="field-label">تسمية القسم (طالب مسجل)</label><InputText v-model="local.auth_label" class="w-100" /></div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field"><label class="field-label">عنوان القسم (طالب مسجل)</label><InputText v-model="local.auth_title" class="w-100" /></div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field"><label class="field-label">تسمية القسم (زائر)</label><InputText v-model="local.guest_label" class="w-100" /></div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field"><label class="field-label">عنوان القسم (زائر)</label><InputText v-model="local.guest_title" class="w-100" /></div>
    </div>

    <div class="col-12">
      <label class="field-label d-block mb-2">بطاقات الطالب المسجل</label>
      <div v-for="(card, idx) in local.auth_cards" :key="idx" class="answer-item">
        <div class="answer-item__index">{{ idx + 1 }}</div>
        <div class="answer-item__content">
          <div class="card-grid">
            <InputText v-model="card.icon" placeholder="أيقونة" />
            <InputText v-model="card.title" placeholder="العنوان" />
            <InputText v-model="card.desc" placeholder="الوصف" />
            <InputText v-model="card.link" placeholder="الرابط" />
            <select v-model="card.accent" class="accent-select">
              <option value="ac-lessons">لون 1</option>
              <option value="ac-exams">لون 2</option>
              <option value="ac-hw">لون 3</option>
              <option value="ac-results">لون 4</option>
            </select>
          </div>
        </div>
        <div class="answer-item__actions"><button type="button" class="answer-remove-btn" @click="local.auth_cards.splice(idx,1)"><i class="pi pi-trash"></i></button></div>
      </div>
      <button type="button" class="add-answer-btn" v-if="local.auth_cards.length < 8" @click="local.auth_cards.push({ icon:'', title:'', desc:'', link:'', accent:'ac-lessons' })">
        <i class="pi pi-plus"></i> إضافة بطاقة
      </button>
    </div>

    <div class="col-12">
      <label class="field-label d-block mb-2">بطاقات الزائر</label>
      <div v-for="(card, idx) in local.guest_cards" :key="idx" class="answer-item">
        <div class="answer-item__index">{{ idx + 1 }}</div>
        <div class="answer-item__content">
          <div class="card-grid card-grid--no-link">
            <InputText v-model="card.icon" placeholder="أيقونة" />
            <InputText v-model="card.title" placeholder="العنوان" />
            <InputText v-model="card.desc" placeholder="الوصف" />
            <select v-model="card.accent" class="accent-select">
              <option value="fc-purple">لون 1</option>
              <option value="fc-blue">لون 2</option>
              <option value="fc-green">لون 3</option>
              <option value="fc-orange">لون 4</option>
            </select>
          </div>
        </div>
        <div class="answer-item__actions"><button type="button" class="answer-remove-btn" @click="local.guest_cards.splice(idx,1)"><i class="pi pi-trash"></i></button></div>
      </div>
      <button type="button" class="add-answer-btn" v-if="local.guest_cards.length < 8" @click="local.guest_cards.push({ icon:'', title:'', desc:'', accent:'fc-purple' })">
        <i class="pi pi-plus"></i> إضافة بطاقة
      </button>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue';
import InputText from 'primevue/inputtext';

const props = defineProps({ modelValue: { type: Object, default: () => ({}) } });
const emit = defineEmits(['update:modelValue']);

const local = reactive({
  auth_label: props.modelValue.auth_label ?? '',
  auth_title: props.modelValue.auth_title ?? '',
  guest_label: props.modelValue.guest_label ?? '',
  guest_title: props.modelValue.guest_title ?? '',
  auth_cards: (props.modelValue.auth_cards ?? []).map((c) => ({ ...c })),
  guest_cards: (props.modelValue.guest_cards ?? []).map((c) => ({ ...c })),
});

watch(local, () => emit('update:modelValue', { ...props.modelValue, ...local }), { deep: true });
</script>

<style scoped>
.card-grid { display: grid; grid-template-columns: 70px 1fr 1.5fr 1fr 90px; gap: .5rem; }
.card-grid--no-link { grid-template-columns: 70px 1fr 1.5fr 90px; }
.accent-select { border: 1px solid var(--border, #e5e7eb); border-radius: 8px; padding: 0 .5rem; }
</style>
